import React from 'react';
import { Box, Autocomplete, TextField } from '@mui/material';

/**
 * TagAutocomplete component for managing tags on transactions
 */
const TagAutocomplete = ({ value, options, onChange, addHistoryEntry, historyManager, rowData }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Autocomplete
        multiple
        freeSolo
        size="small"
        options={[...options].sort()}
        value={value || []}
        onKeyDown={(event) => {
          // Prevent the default space behavior that causes focus loss
          if (event.key === ' ') {
            event.stopPropagation();
          }
        }}
        onChange={(event, newValue) => {
          // Update the tags directly
          const updatedTags = [...newValue].map(tag => tag.toLowerCase().trim());
          const oldTags = value || [];
          
          // Handle history entry
          const addedTags = updatedTags.filter(tag => !oldTags.includes(tag.toLowerCase().trim()));
          const removedTags = oldTags.filter(tag => !updatedTags.includes(tag.toLowerCase().trim()));
          
          if (addedTags.length > 0 || removedTags.length > 0) {
            const changes = [];
            if (addedTags.length > 0) {
              changes.push(`added: ${addedTags.join(', ')}`);
            }
            if (removedTags.length > 0) {
              changes.push(`removed: ${removedTags.join(', ')}`);
            }
            addHistoryEntry(historyManager.createSingleChangeEntry(
              rowData,
              {
                field: 'tags',
                valueBefore: oldTags,
                valueAfter: updatedTags,
                tagsChanged: changes
              },
            ));
          }
          
          onChange(updatedTags);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Add tags..."
            size="small"
          />
        )}
        filterOptions={(options, params) => {
          const filtered = options.filter(option => 
            option.toLowerCase().includes(params.inputValue.toLowerCase().trim())
          );
          // If there's no exact match and we have an input value
          if (params.inputValue.trim() !== '' && 
              !filtered.some(option => option.toLowerCase() === params.inputValue.toLowerCase().trim())) {
            // Put the entered value at the beginning of the array
            return [params.inputValue.toLowerCase().trim(), ...filtered];
          }
          return filtered;
        }}
      />
    </Box>
  );
};

export default TagAutocomplete;